export default [
  { prop: 'data.name', header: 'Name' },
  { prop: 'data.email', header: 'Email' },
  { prop: 'data.stats', header: 'Stats' },
]
